import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { CustomCheckoutReviewAndSubmitState } from "@preferredMedical/Store/Pages/CheckoutReviewAndSubmit/CustomCheckoutReviewAndSubmitState";
import { Draft } from "immer";


const initialState: CustomCheckoutReviewAndSubmitState = {
    hasAgreedToTerms: false,
    notes: "",
    isBlindShipment: "False",
}

const reducer = {
    "Custom/Pages/CheckoutReviewAndSubmit/SetConsent": (draft: Draft<CustomCheckoutReviewAndSubmitState>, action: { consent: boolean }) => {
        draft.hasAgreedToTerms = action.consent;
    },
    "Custom/Pages/CheckoutReviewAndSubmit/SetNotes": (draft: Draft<CustomCheckoutReviewAndSubmitState>, action: { notes: string }) => {
        draft.notes = action.notes;
    },
    "Custom/Pages/CheckoutReviewAndSubmit/SetIsBlindShipment": (draft: Draft<CustomCheckoutReviewAndSubmitState>, action: { isBlindShipment: string }) => {
        draft.isBlindShipment = action.isBlindShipment;
    },
}

export default createTypedReducerWithImmer(initialState, reducer);